import { useState } from 'react';
import { CreditCard, Shield, Clock, Globe, ChevronDown, Info } from 'lucide-react';
import './BuyCrypto.css';

const BuyCrypto = () => {
  const [amount, setAmount] = useState('');
  const [currency, setCurrency] = useState('USD');
  const [crypto, setCrypto] = useState('BTC');

  const fiatCurrencies = [
    { code: 'USD', name: 'US Dollar', symbol: '$' },
    { code: 'EUR', name: 'Euro', symbol: '€' },
    { code: 'GBP', name: 'British Pound', symbol: '£' },
    { code: 'CAD', name: 'Canadian Dollar', symbol: 'C$' },
    { code: 'AUD', name: 'Australian Dollar', symbol: 'A$' },
  ];

  const cryptoCurrencies = [
    { code: 'BTC', name: 'Bitcoin', price: 43250 },
    { code: 'ETH', name: 'Ethereum', price: 2780 },
    { code: 'USDT', name: 'Tether', price: 1 },
    { code: 'SOL', name: 'Solana', price: 98.5 },
    { code: 'BNB', name: 'BNB', price: 315 },
  ];

  const features = [
    { icon: Shield, title: 'Secure Payments', desc: 'Bank-level encryption' },
    { icon: Clock, title: 'Instant Delivery', desc: 'Crypto in your wallet fast' },
    { icon: Globe, title: 'Global Coverage', desc: '150+ countries supported' },
    { icon: CreditCard, title: 'Multiple Options', desc: 'Card, bank, and more' },
  ];

  const estimatedCrypto = amount 
    ? (parseFloat(amount) / cryptoCurrencies.find(c => c.code === crypto).price).toFixed(6)
    : '0';

  return (
    <div className="buy-crypto-page">
      <div className="page-container">
        <div className="page-header">
          <h1>Buy <span className="gradient-text">Cryptocurrency</span></h1>
          <p>Purchase crypto instantly with your credit card or bank transfer</p>
        </div>

        <div className="buy-content">
          <div className="buy-widget">
            <div className="widget-tabs">
              <button className="tab active">Buy</button>
              <button className="tab">Sell</button>
            </div>

            <div className="buy-form">
              <div className="input-row">
                <label className="input-label">You Pay</label>
                <div className="input-field-wrapper">
                  <input
                    type="number"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    placeholder="100"
                    className="amount-input"
                  />
                  <div className="currency-select">
                    <select value={currency} onChange={(e) => setCurrency(e.target.value)}>
                      {fiatCurrencies.map((fc) => (
                        <option key={fc.code} value={fc.code}>
                          {fc.code}
                        </option>
                      ))}
                    </select>
                    <ChevronDown className="select-arrow" />
                  </div>
                </div>
              </div>

              <div className="exchange-arrow">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 16V4M7 4L3 8M7 4L11 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M17 8V20M17 20L21 16M17 20L13 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>

              <div className="input-row">
                <label className="input-label">You Receive</label>
                <div className="input-field-wrapper">
                  <input
                    type="text"
                    value={estimatedCrypto}
                    readOnly
                    className="amount-input readonly"
                  />
                  <div className="currency-select">
                    <select value={crypto} onChange={(e) => setCrypto(e.target.value)}>
                      {cryptoCurrencies.map((cc) => (
                        <option key={cc.code} value={cc.code}>
                          {cc.code}
                        </option>
                      ))}
                    </select>
                    <ChevronDown className="select-arrow" />
                  </div>
                </div>
              </div>

              <div className="rate-info">
                <div className="rate-row">
                  <span>Rate</span>
                  <span>1 {crypto} ≈ ${cryptoCurrencies.find(c => c.code === crypto).price.toLocaleString()}</span>
                </div>
                <div className="rate-row">
                  <span>Fees</span>
                  <span>From 1%</span>
                </div>
              </div>

              <button className="buy-button">
                <CreditCard className="btn-icon" />
                Continue with Card
              </button>

              <div className="disclaimer">
                <Info className="info-icon" />
                <p>Service provided by third-party payment processors. KYC verification may be required.</p>
              </div>
            </div>
          </div>

          <div className="buy-features">
            {features.map((feature, index) => (
              <div key={index} className="feature-item">
                <div className="feature-icon-box">
                  <feature.icon className="feature-icon" />
                </div>
                <div className="feature-text">
                  <h4>{feature.title}</h4>
                  <p>{feature.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="payment-methods">
          <h3>Accepted Payment Methods</h3>
          <div className="methods-grid">
            <div className="method-card">
              <CreditCard className="method-icon" />
              <span>Credit/Debit Card</span>
            </div>
            <div className="method-card">
              <span className="method-icon bank">🏦</span>
              <span>Bank Transfer</span>
            </div>
            <div className="method-card">
              <span className="method-icon apple">🍎</span>
              <span>Apple Pay</span>
            </div>
            <div className="method-card">
              <span className="method-icon google">G</span>
              <span>Google Pay</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuyCrypto;
